import React, { useState } from 'react';
import styled from '@emotion/styled';
import DotsLoading from '../ui/DotsLoading';
import { Eye, EyeOff } from 'lucide-react';

const Form = styled.form`
  width: 100%;
  max-width: 420px;
`;
const FormGroup = styled.div`
  margin-bottom: 28px;
  label {
    display: block;
    color: #ffffff;
    font-size: 16px;
    margin-bottom: 8px;
    font-weight: 500;
  }
`;
const FormInput = styled.input`
  width: 100%;
  height: 55px;
  background: #1E1E35;
  border: 1px solid #1E1E35;
  border-radius: 12px;
  padding: 0 20px;
  padding-right: 50px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
  &::placeholder { color: rgba(255,255,255,0.6); }
  &:focus { border-color: rgba(255,255,255,0.5); }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const PasswordToggle = styled.button`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.1);
  }
  
  &:active {
    transform: translateY(-50%) scale(0.95);
  }
  
  svg {
    width: 18px;
    height: 18px;
  }
`;
const SubmitButton = styled.button`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F43F60;
  border: none;
  border-radius: 12px;
  color: #EDEDED;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 16px;
  &:hover:not(:disabled) { background: #E03A56; }
  &:disabled { background: #666666; cursor: not-allowed; opacity: 0.7; }
`;
const ErrorMessage = styled.div`
  background: rgba(244, 63, 96, 0.1);
  border: 1px solid #F43F60;
  color: #F43F60;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
`;
const SuccessMessage = styled.div`
  background: #25253C;
  border: 1px solid #22C55E;
  color: #22C55E;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
`;

const Section = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
`;

const SectionTitle = styled.h3`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PasswordChangeForm = ({ values, onChange, onSubmit, isSubmitting, error, success }) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
  <Section>
    <Form onSubmit={onSubmit} style={{ maxWidth: 'unset' }}>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {success && <SuccessMessage>{success}</SuccessMessage>}
      <FormGroup>
        <label htmlFor="newPassword">New Password</label>
          <InputContainer>
        <FormInput
              type={showNewPassword ? "text" : "password"}
          id="newPassword"
          name="newPassword"
          value={values.newPassword}
          onChange={onChange}
          placeholder="Enter new password"
          required
        />
            <PasswordToggle
              type="button"
              onClick={() => setShowNewPassword(!showNewPassword)}
              title={showNewPassword ? "Hide password" : "Show password"}
            >
              {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </PasswordToggle>
          </InputContainer>
      </FormGroup>
      <FormGroup>
        <label htmlFor="confirmPassword">Confirm Password</label>
          <InputContainer>
        <FormInput
              type={showConfirmPassword ? "text" : "password"}
          id="confirmPassword"
          name="confirmPassword"
          value={values.confirmPassword}
          onChange={onChange}
          placeholder="Re-type new password"
          required
        />
            <PasswordToggle
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              title={showConfirmPassword ? "Hide password" : "Show password"}
            >
              {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </PasswordToggle>
          </InputContainer>
      </FormGroup>
      <SubmitButton type="submit" disabled={isSubmitting}>
        {isSubmitting ? <DotsLoading /> : 'Save Password'}
      </SubmitButton>
    </Form>
  </Section>
);
};

export default PasswordChangeForm; 